import { useEffect, useState } from "react";
import { api, AuditEvent } from "./api";
import { ListControls, usePagedList } from "./Pagination";
import { FilterBar, PageHeader } from "./ui";

// Tela de auditoria: filtros por coluna/período e paginação client-side sobre a
// lista que o endpoint devolve (limitada a 250 eventos).
export function AuditPage() {
  const [events, setEvents] = useState<AuditEvent[]>([]);
  const [error, setError] = useState("");
  const [action, setAction] = useState("");
  const [actor, setActor] = useState("");
  const [target, setTarget] = useState("");
  const [ip, setIp] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const filtered = events.filter((event) => {
    const occurred = new Date(event.occurredAt).getTime();
    if (from && occurred < new Date(from).getTime()) return false;
    if (to && occurred > new Date(to).getTime()) return false;
    if (action && !event.action.toLowerCase().includes(action.toLowerCase())) return false;
    if (actor && !event.actorType.toLowerCase().includes(actor.toLowerCase())) return false;
    if (target && !`${event.targetType ?? ""} ${event.targetId ?? ""}`.toLowerCase().includes(target.toLowerCase())) return false;
    if (ip && !(event.ipAddress ?? "").includes(ip.trim())) return false;
    return true;
  });
  const paged = usePagedList(filtered);
  useEffect(() => {
    api
      .audit()
      .then(setEvents)
      .catch((e) => setError(e.message));
  }, []);
  return (
    <>
      <PageHeader
        eyebrow="SEGURANÇA"
        title="Auditoria"
        subtitle="Registro imutável das ações administrativas e dos agentes."
      />
      {error && <p className="error">{error}</p>}
      <FilterBar>
        <label>
          Ação
          <input value={action} onChange={(event) => setAction(event.target.value)} placeholder="ex.: auth.login" />
        </label>
        <label>
          Ator (tipo)
          <input value={actor} onChange={(event) => setActor(event.target.value)} placeholder="ex.: user" />
        </label>
        <label>
          Alvo (tipo ou id)
          <input value={target} onChange={(event) => setTarget(event.target.value)} placeholder="ex.: device" />
        </label>
        <label>
          IP
          <input value={ip} onChange={(event) => setIp(event.target.value)} placeholder="ex.: 192.168." />
        </label>
        <label>
          De
          <input type="datetime-local" value={from} onChange={(event) => setFrom(event.target.value)} />
        </label>
        <label>
          Até
          <input type="datetime-local" value={to} onChange={(event) => setTo(event.target.value)} />
        </label>
      </FilterBar>
      <section className="panel">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Quando</th>
                <th>Ação</th>
                <th>Ator</th>
                <th>Alvo</th>
                <th>IP</th>
              </tr>
            </thead>
            <tbody>
              {paged.pageItems.map((event) => (
                <tr key={event.id}>
                  <td>{new Date(event.occurredAt).toLocaleString("pt-BR")}</td>
                  <td>
                    <strong>{event.action}</strong>
                  </td>
                  <td>{event.actorType}</td>
                  <td>{event.targetType ?? "—"}</td>
                  <td>{event.ipAddress ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {!filtered.length && (
            <div className="empty">
              <b>Nenhum evento</b>
              <span>Ajuste os filtros ou o período.</span>
            </div>
          )}
        </div>
        <ListControls page={paged.page} pages={paged.pages} size={paged.size} total={paged.total} onSize={paged.changeSize} onPrev={paged.prev} onNext={paged.next} />
      </section>
    </>
  );
}
